import { useRequest } from 'ahooks';
import { Tag, message } from 'antd';
import { useState } from 'react';
import { aiAssistantApi } from '../../api/aiAssistant';
import { useCompany } from '../../hooks/company';
import ChatWindow from './ChatWindow';
import ConversationList from './ConversationList';
import { deriveAiScopeLabel } from './scope';

const AiAssistant = () => {
  const { id: companyId, currentUser, hasPermission } = useCompany();
  const [activeId, setActiveId] = useState<string | null>(null);

  const scopeLabel = deriveAiScopeLabel({
    isSuperAdmin: currentUser?.isSuperAdmin,
    departmentId: currentUser?.departmentId,
    hasPermission,
  });

  const {
    data: conversationPage,
    loading,
    refresh,
  } = useRequest(() => aiAssistantApi.listConversations(companyId, 1, 100), {
    refreshDeps: [companyId],
  });

  const handleRename = async (id: string, title: string) => {
    await aiAssistantApi.updateTitle(companyId, id, title);
    message.success('已重命名');
    refresh();
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        height: 'calc(100vh - 64px - 50px - 48px)',
      }}
    >
      <div>
        {/* 纯展示（与后端解析规则一致），真实数据边界在后端按角色权限码收敛 */}
        <Tag color="blue">数据范围：{scopeLabel}</Tag>
      </div>
      <div style={{ display: 'flex', gap: 16, flex: 1, minHeight: 0 }}>
        <ConversationList
          conversations={conversationPage?.list || []}
          loading={loading}
          activeId={activeId}
          onSelect={setActiveId}
          onNew={() => setActiveId(null)}
          onRename={handleRename}
        />
        <ChatWindow
          companyId={companyId}
          conversationId={activeId}
          onConversationCreated={(id) => {
            setActiveId(id);
            refresh();
          }}
          onRoundFinished={refresh}
        />
      </div>
    </div>
  );
};

export default AiAssistant;
